import { TrendUp, TrendDown } from "@phosphor-icons/react";

const kebab = (s) => String(s || "").toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-").replace(/^-+|-+$/g, "");

// Carte de métrique (KPI) premium pour tableaux de bord (KAIZEN SYSTEM).
export function StatCard({ label, value, trend, trendDirection, icon: Icon, tone = "amber", onClick }) {
  const TrendIcon = trendDirection === "down" ? TrendDown : TrendUp;
  const trendClasses =
    trendDirection === "down"
      ? "text-red-400 bg-red-400/10"
      : "text-emerald-400 bg-emerald-400/10";
  const Comp = onClick ? "button" : "div";
  return (
    <Comp
      type={onClick ? "button" : undefined}
      onClick={onClick}
      data-testid={`stat-card-${kebab(label)}`}
      className={`p-6 rounded-xl bg-zinc-900 border border-zinc-800 flex flex-col gap-3 group hover:border-amber-500/30 transition-colors relative overflow-hidden text-left ${onClick ? "cursor-pointer active:scale-[0.99]" : ""}`}
    >
      {Icon && (
        <Icon
          size={128}
          weight="duotone"
          className="absolute -right-6 -top-6 text-zinc-800/40 w-32 h-32 transform group-hover:scale-110 transition-transform duration-500 pointer-events-none"
        />
      )}
      <div className="flex justify-between items-start text-zinc-400 text-sm font-medium font-manrope relative z-10">
        <span>{label}</span>
        {trend != null && trend !== "" && (
          <span className={`text-xs font-bold px-2 py-1 rounded-md flex items-center gap-1 ${trendClasses}`}>
            <TrendIcon size={12} weight="bold" /> {trend}
          </span>
        )}
      </div>
      <div className={`text-3xl font-bold font-cabinet tracking-tight relative z-10 ${tone === "amber" ? "text-zinc-50" : ""}`}>
        {value}
      </div>
    </Comp>
  );
}

export default StatCard;
